module.exports = __webpack_public_path__ + "static/media/consultant.0da02865.jpg";